// ==========================================================================
// groots core
// Author: Globalia
// Licensed under the WTFPL license
// ==========================================================================

window.jquery = window.jQuery = window.$ = require('jquery'); // Will be removed

var sassToJs = require('sass-to-js');

window.groots.methods = {

    objectAssign : Object.assign || function (srcObj) { // eslint-disable-line
        for (var i = 1; i < arguments.length; i++) {
            for (var objProperty in arguments[i]) {
                if (Object.prototype.hasOwnProperty.call(arguments[i], objProperty)) srcObj[objProperty] = arguments[i][objProperty];
            }
        }
        return srcObj;
    },

    debounce : function (func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    },

    isVisible : function (el) {
        var windowWidth = window.innerWidth,
            windowHeight = window.innerHeight;
        if (windowWidth === null || windowHeight === null) return false;
        var rect = el.getBoundingClientRect();
        var elTop = rect.top;
        var elLeft = rect.left;
        var elWidth = rect.width;
        var elHeight = rect.height;
        return elTop < windowHeight && elTop + elHeight > 0 && elLeft < windowWidth && elLeft + elWidth > 0;
    },

    // Add or toggle an attribute value
    toggleAttributeValue : function (el, attribute, value, toggleClass) {
        if (toggleClass === undefined) toggleClass = false;
        if (!el || !el.hasAttribute(attribute)) return;

        var values = el.getAttribute(attribute).split(' ');
        var existingIndex = values.indexOf(value);

        if (existingIndex >= 0) values.splice(existingIndex, 1);
        else values.push(value);
        if (toggleClass) el.classList.toggle('gr-' + value);

        el.setAttribute(attribute, values.join(' '));
    },

    // Remove attribute value(s)
    removeAttributeValue : function (el, attribute, value, removeClass) {
        if (removeClass === undefined) removeClass = false;
        if (!el || !el.hasAttribute(attribute)) return;
        var values = el.getAttribute(attribute).split(' ');

        var valuesToRemove = value.split(' ');

        for (var i = valuesToRemove.length - 1; i >= 0; i--) {
            var existingIndex = values.indexOf(valuesToRemove[i]);
            if (existingIndex >= 0) values.splice(existingIndex, 1);
            if (removeClass) el.classList.remove('gr-' + valuesToRemove[i]);
        }

        el.setAttribute(attribute, values.join(' '));
    },

    // Wrap wrapper around nodes
    wrapAll : function (nodes, wrapper) {
        // Cache the current parent and previous sibling of the first node.
        var parent = nodes[0].parentNode;
        var previousSibling = nodes[0].previousSibling;

        // Place each node in wrapper.
        //  - If nodes is an array, we must increment the index we grab from
        //    after each loop.
        //  - If nodes is a NodeList, each node is automatically removed from
        //    the NodeList when it is removed from its parent with appendChild.
        for (var i = 0; nodes.length - i; wrapper.firstChild === nodes[0] && i++) {
            wrapper.appendChild(nodes[i]);
        }

        // Place the wrapper just after the cached previousSibling,
        // or if that is null, just before the first child.
        var nextSibling = previousSibling ? previousSibling.nextSibling : parent.firstChild;
        parent.insertBefore(wrapper, nextSibling);

        return wrapper;
    },

    // A vanilla javascript method that returns the closest DOM ancestor that matches a selector, or null.
    closest : function (selector, ele) {
        if (!selector || !ele)
            return null;

        //polyfill .matches()
        if (Element && !Element.prototype.matches) {
            Element.prototype.matches = Element.prototype.matchesSelector
            || Element.prototype.mozMatchesSelector
            || Element.prototype.msMatchesSelector
            || Element.prototype.oMatchesSelector
            || Element.prototype.webkitMatchesSelector;
        }

        if (ele.matches(selector))
            return ele; //return self if it matches

        var parent = ele.parentNode;
        var i = 0;

        while (!parent.matches(selector)) {
            parent = parent.parentNode;
            if (parent.tagName == undefined)
                return null; //reached the end of the DOM tree
            if (i >= 100)
                return null; //emergency break
            i += 1;
        }

        return parent;
    }
}

// for (var i = Object.keys(window.groots.require).length - 1; i >= 0; i--) {
//     var key = Object.keys(window.groots.require)[i];
//     var value = Object.values(window.groots.require)[i];
//     var path = '~/docker/vhosts/artopex-siteweb/groots/garden/buds/' + key + '/' + key + '.js';
//     console.log(path)
//     if (window.groots[key] === undefined && value) {
//         window.groots[key] = require(path);
//         //window.groots[key] = {};
//         window.groots[key].elements = {};
//     }
// }

// Require groots JS-Plugins
if (window.groots.grInlineSVG === undefined && window.groots.require.grInlineSVG) var grInlineSVG = require('./buds/grInlineSVG/grInlineSVG.js')
// if (window.groots.grObjectfitEmulator === undefined && window.groots.require.grObjectfitEmulator) var grObjectfitEmulator = require('./buds/grObjectfitEmulator/grObjectfitEmulator.js');
// if (window.groots.grEqualizer === undefined && window.groots.require.grEqualizer) var grEqualizer = require('./buds/grEqualizer/grEqualizer.js');
if (window.groots.grLazyLoader === undefined && window.groots.require.grLazyLoader) var grLazyLoader = require('./buds/grLazyLoader/grLazyLoader.js');
if (window.groots.grNavigation === undefined && window.groots.require.grNavigation) var grNavigation = require('./buds/grNavigation/grNavigation.js');
// if (window.groots.grAccTabs === undefined && window.groots.require.grAccTabs) var grAccTabs = require('./buds/grAccTabs/grAccTabs.js');
// if (window.groots.grFormSelect === undefined && window.groots.require.grFormSelect) var grFormSelect = require('./buds/grFormSelect/grFormSelect.js');
if (window.groots.grFormUpload === undefined && window.groots.require.grFormUpload) var grFormUpload = require('./buds/grFormUpload/grFormUpload.js');
// if (window.groots.grFormNormalize === undefined && window.groots.require.grFormNormalize) var grFormNormalize = require('./buds/grFormNormalize/grFormNormalize.js');
if (window.groots.grFormValidation === undefined && window.groots.require.grFormValidation) var grFormValidation = require('./buds/grFormValidation/grFormValidation.js');
// if (window.groots.grGoogleMap === undefined && window.groots.require.grGoogleMap) var grGoogleMap = require('./buds/grGoogleMap/grGoogleMap_o.js');
// if (window.groots.grVideoYoutube === undefined && window.groots.require.grVideoYoutube) var grVideoYoutube = require('./buds/grVideoYoutube/grVideoYoutube.js');
if (window.groots.grDropdown === undefined && window.groots.require.grDropdown) var grDropdown = require('./buds/grDropdown/grDropdown.js');

// Instantiation of groots JS-Plugins
( function( global ) {

    "use strict"; // Start of use strict

    // Set Breakpoints Map
    global.sassBreakpoints = sassToJs( document.querySelector('body'), { pseudoEl: ':before', cssProperty: 'content', debug: true } );

    // gr-Instantiation
    var all = {}, index;

    if (document.querySelectorAll('[gr-svg-inliner]').length && window.groots.require.grInlineSVG == 'auto') {
        window.groots.grInlineSVG = { instances: {} };
        all = document.querySelectorAll('[gr-svg-inliner]');
        index = -1;
        while (all[++index])
            global.grInlineSVG.instances[index] = new grInlineSVG(all[index]);
    }

    if (document.querySelectorAll('[gr-equalizer]').length && window.groots.require.grEqualizer == 'auto') {
        window.groots.grEqualizer = { instances: {} };
        all = document.querySelectorAll('[gr-equalizer]');
        index = -1;
        while (all[++index])
            global.grEqualizer.instances[index] = new grEqualizer(all[index]);
    }

    if (document.querySelectorAll('[gr-lazyloader]').length && window.groots.require.grLazyLoader == 'auto') {
        window.groots.grLazyLoader = { instances: {} };
        all = document.querySelectorAll('[gr-lazyloader]');
        index = -1;
        while (all[++index])
            global.grLazyLoader.instances[index] = new grLazyLoader(all[index]);
    }

    if (/MSIE|Trident|Edge/.test(navigator.userAgent) && document.querySelectorAll('img, video').length && window.groots.require.grObjectfitEmulator == 'auto') {
        window.groots.grObjectfitEmulator = { instances: {} };
        all = document.querySelectorAll('img, video');
        index = -1;
        while (all[++index]) {
            var node = all[index];
            if(node.currentStyle)
                var objectFit = node.currentStyle['object-fit'];
            else if(window.getComputedStyle)
                var objectFit = document.defaultView.getComputedStyle(node, null).getPropertyValue('font-family');

            if (objectFit && /^(contain|cover|"cover")$/.test(objectFit))
                global.grObjectfitEmulator.instances[index] = new grObjectfitEmulator(all[index]);
        }
    }

    if (document.querySelectorAll('[gr-form-upload]').length && window.groots.require.grFormUpload == 'auto') {
        window.groots.grFormUpload = { instances: {} };
        all = document.querySelectorAll('[gr-form-upload]');
        index = -1;
        while (all[++index])
            global.grFormUpload.instances[index] = new grFormUpload(all[index]);
    }

    if (document.querySelectorAll('[gr-form] select').length && window.groots.require.grFormSelect == 'auto') {
        window.groots.grFormSelect = { instances: {} };
        all = document.querySelectorAll('[gr-form] select');
        index = -1;
        while (all[++index])
            global.grFormSelect.instances[index] = new grFormSelect(all[index]);
    }

    if (document.querySelectorAll('[gr-nav]').length && window.groots.require.grNavigation == 'auto') {
        window.groots.grNavigation = { instances: {} };
        all = document.querySelectorAll('[gr-nav]');
        index = -1;
        while (all[++index])
            global.grNavigation.instances[index] = new grNavigation(all[index]);
    }

    if (document.querySelectorAll('[gr-acc-tabs]').length && window.groots.require.grAccTabs == 'auto') {
        window.groots.grAccTabs = { instances: {} };
        all = document.querySelectorAll('[gr-acc-tabs]');
        index = -1;
        while (all[++index])
            global.grAccTabs.instances[index] = new grAccTabs(all[index]);
    }

    if (document.querySelectorAll('[gr-video-youtube]').length && window.groots.require.grVideoYoutube == 'auto') {
        window.groots.grVideoYoutube = { instances: {} };
        all = document.querySelectorAll('[gr-video-youtube]');
        index = -1;
        while (all[++index])
            global.grVideoYoutube.instances[index] = new grVideoYoutube(all[index]);
    }

    if (document.querySelectorAll('[gr-dropdown]').length && window.groots.require.grDropdown == 'auto') {
        window.groots.grDropdown = { instances: {} };
        all = document.querySelectorAll('[gr-dropdown]');
        index = -1;
        while (all[++index])
            global.grDropdown.instances[index] = new grDropdown(all[index]);
    }

} )( window.groots );
